<template>
    <div class="vh-100 d-flex flex-row align-items-center justify-content-center">
        <div class="card">
            <div class="card-body">
                <form
                    enctype="application/x-www-form-urlencoded"
                    autocomplete="off"
                    @submit.prevent="onSubmit"
                >
                    <div class="mb-3">
                        <label for="email" class="form-label">{{ $t('login.field.email') }}</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            v-model="form.email"
                            class="form-control"
                            :class="[errors.email ? 'is-invalid' : '']"
                            :placeholder="$t('login.field.email')"
                        />
                        <FormError v-if="errors.email">
                            {{ errors.email }}
                        </FormError>
                    </div>

                    <div class="mb-3">
                        <label for="password" class="form-label">{{ $t('login.field.password') }}</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            v-model="form.password"
                            class="form-control"
                            :class="[errors.password ? 'is-invalid' : '']"
                            :placeholder="$t('login.field.password')"
                        />
                        <FormError v-if="errors.password">
                            {{ errors.password }}
                        </FormError>
                    </div>

                    <div class="mb-3">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="form.remember"
                                id="remember"
                            >
                            <label
                                class="form-check-label"
                                for="remember"
                            >
                                {{ $t('login.field.remember') }}
                            </label>
                        </div>
                    </div>

                    <div class="mb-3 text-end">
                        <button type="submit" class="btn btn-primary">
                            {{ $t('login.field.submit') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { useForm } from '@inertiajs/vue3'
import FormError from "../../components/FormError.vue";

export default {
    name: "Login",
    props: {
        errors: Object,
        app: String
    },
    data() {
        return {
            form: useForm({
                email: "",
                password: "",
                remember: false,
            })
        }
    },
    methods: {
        onSubmit() {
            this.form.post("/merchant/login")
        }
    },
    components: {
        FormError
    },
}
</script>

<style scoped>
.card {
    width: 100%;
    max-width: 25rem;
}
</style>
